import { render } from "./MaterialComponent.vue?vue&type=template&id=740fd5de&scoped=true"
import script from "./MaterialComponent.vue?vue&type=script&lang=js"
export * from "./MaterialComponent.vue?vue&type=script&lang=js"

import "./MaterialComponent.vue?vue&type=style&index=0&id=740fd5de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740fd5de"]])

export default __exports__